module.exports = __webpack_public_path__ + "static/media/highlightSupport.ab81fe53.svg";